import { BASE_URL } from '../../../../../../../utils/config.base-url'

export const PROJECT_MEMBER_PREFIX_URL = '/project-member'
export const URL_ENDPOINT_PROJECT_MEMBER = `${BASE_URL}/project-member`
